<template>
		<transition v-if="!$route.meta.template" name="fade" mode="out-in">
			<el-container class="h-100">
				<el-header class="px-0 w-100  " :class="isshow?'el-headers':''" style="line-height: 60px;box-shadow: 0 2px 4px 0 var(--cb-color-shadow,rgba(0,0,0,0.16));"    >
					<div class="pull-left ">
						<!-- <div  :class="{ 'header-logo-200': !menuOpen, 'header-logo-64': menuOpen }"
						style="background-repeat:no-repeat;background-color: #001529;opacity: 0.65;width: 200px;"
						:style="{height:'60px', backgroundImage : 'url('+$domain+logo+')',backgroundSize: (menuOpen?'50%':'contain'),backgroundPosition:(menuOpen?'50% 50%':'0% 50%')}" >
							
						</div> -->
						<div class="pl-4"><img width="40" height="40" style="vertical-align: middle;" src="~@/assets/logossr.png"></img><span style="color: #333;font-weight: 700;letter-spacing: 2px;" class="pl-2 f18">后台管理系统</span></div>
							<!-- <el-breadcrumb separator-class="el-icon-arrow-right " style="line-height: 60px;"  class="   z-20" >
								 <template v-for="(item,index) in $route.matched" >
									 <el-breadcrumb-item  v-if="item.path!='/'&&item.path!=''&&index<$route.matched.length-1">
									 	<span>{{stateLanguage=='en'?item.meta.englishName:item.meta.name}}</span>
									 </el-breadcrumb-item>
								 </template>
								<el-breadcrumb-item :to="{ path: $store.state.menu.path+$store.state.menu.params }" v-if="$store.state.menu&&$store.state.menu.path!='/'">
								 	<span @click="pageReturn">{{$store.state.menu.name}}</span>
								 </el-breadcrumb-item>
								<el-breadcrumb-item  v-if="stateOperate=='添加'||stateOperate=='编辑'||stateOperate=='详情'||stateOperate=='复制'">
									<span @click="pageReturn"  >{{stateOperate}}</span> 
								</el-breadcrumb-item>
							</el-breadcrumb> -->
					</div>
					<div class="pull-right">
						<ul class="list-none p-0 m-0">
							<li v-if="$route.path!='/'" style="max-height: 60px;" lass="mx-4">
								<span @click="goIndex" class="el-dropdown-link "
									style="font-size:14px">{{$t("app.home")}}</span>
							</li>
							<li  style="max-height: 60px;"class="mx-4">
								<el-popover 
									   placement="bottom"
									   width="200"
									   trigger="hover"  @show="popoverShow">
									<el-image  style="width: 100%; height: 100%" :src="urls"  ></el-image>
										<span  slot="reference" class="el-dropdown-link "	style="font-size:14px">手机端</span>
									</el-popover>
							</li>
							<li style="max-height: 60px;" class="mx-4">
							
									<el-popover
									   placement="bottom"
									   title="12.15更新"
									   width="400"
									   trigger="hover"
									   content="1.扫码登录系统,2.商家二维码">
								<!-- <el-badge style="font-size:14px" slot="reference" is-dot class="badge-item el-dropdown-link badge-class">
									{{$t("app.message")}}</el-badge> -->
									<el-badge value="new" slot="reference" class="item el-dropdown-link f14 badge-classr">
									{{$t("app.message")}}
									</el-badge>
									</el-popover>
									 <!-- <el-popover
									    placement="bottom"
									    title="更新提示"
									    width="400"
									    trigger="hover"
									    content="1.调整订单池一些已知问题,2.jhdms系统加入搜索字段,3.优化数据权限,4.修复部分导出异常问题.">
									<el-badge value="new" slot="reference" class="item el-dropdown-link ">
									{{$t("app.message")}}
									</el-badge>
									</el-popover> -->
							</li>
							<li style="max-height: 60px;" class="ml-4 ">
							<span class=" "
								style="font-size:14px;color:#333">{{getRoleName}}</span>
							</li>
							<li style="max-height: 60px;" class="ml-4 ">
							<span class=" "
								style="font-size:14px;color:#333">{{$store.state.user.name}}</span>
							</li>
						<!-- 	<li style="max-height: 60px;" class="mx-4">
								<el-dropdown style="max-height:30px" trigger="hover">
									<span class=" el-dropdown-link">
										{{$t("app.language")}}<i class="el-icon-arrow-down  el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item @click.native="setLanguage('zh')"
											:disabled="userInfo().language=='zh'">中文</el-dropdown-item>
										<el-dropdown-item @click.native="setLanguage('en')"
											:disabled="userInfo().language=='en'">English</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</li> -->
							<li class="ml-1 mr-3" style="max-height: 60px;">
								<el-dropdown style="max-height:40px" trigger="hover">
									<span class="relative el-dropdown-link">
										<span class=" relative text-white"
											style="vertical-align:top;">{{userInfo().language=="en"?userInfo().englishName:userInfo().userName}}</span>
										<el-avatar class="my-2 " style="background: #fff;"
											:src="userInfo().avatarUrl?userInfo().avatarUrl:defaultFemalea">
										</el-avatar>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item>
											<div @click="topersonalCenter">{{$t("app.personalCenter")}}</div>
										</el-dropdown-item>
										<el-dropdown class="w-100" placement="left">
											<el-dropdown-item >
												{{$t("app.switchRoles")}}</el-dropdown-item>
											<el-dropdown-menu slot="dropdown">
												<el-dropdown-item @click.native="witchRoleClick(item)"
												     :disabled="userInfo().roleId==item.id"	 :key="item.id" v-for="item in userInfo().roleList">
													{{userInfo().language=="en"?item.englishName:item.name}}
												</el-dropdown-item>
											</el-dropdown-menu>
				
										</el-dropdown>
										<el-dropdown-item disabled>{{$t("app.setting")}}</el-dropdown-item>
										<el-dropdown-item @click.native="logout" divided>{{$t("app.quit")}}
										</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</li>
						</ul>
					</div>
				</el-header>
				<section class="el-container">
					<!-- <el-aside :width="!menuOpen?'200px':'64px'" class="pull-left" style="background-color:#001529;height: calc(100vh - 60px);overflow-x: hidden;">
						
					<el-menu :default-active="$route.fullPath" :collapse-transition="false"
						:class="{ 'header-logo-200': !menuOpen, 'header-logo-64': menuOpen }"
						   background-color="#001529"
						class="el-menu-vertical-demo p-0 m-0 "   :collapse="menuOpen" unique-opened
						router>
						<appMenu
						              v-for="(item,index) in routes"
						              :key="index" 
						              :item="item"
						            />
					</el-menu>
					
					  </el-aside> -->
					 
				<div :width="!menuOpen?'200px':'64px'"  style="height: calc(100vh - 60px);overflow-x: hidden;box-shadow: 0 0 10px 0 rgb(0 0 0 / 15%);margin-right: 10px;width: 200px;background-color: #fff;">
				<el-menu :default-active="$route.fullPath" :collapse-transition="false" 
					:class="{ 'header-logo-200': !menuOpen, 'header-logo-64': menuOpen }"
					
					class="el-menu-vertical-demo p-0 m-0 h-100"   :collapse="menuOpen" unique-opened
					router>
					<appMenu
					              v-for="(item,index) in routes"
					              :key="index" 
					              :item="item"
					            />
				</el-menu>
				  </div>
						<div  class="container-mian relative" ref="containerRef"  style="overflow-y: auto;width: calc(100vw - 200px);height: calc(100vh - 60px);background: #f3f3f3;">
						<!-- <div v-if="stateOperate!='添加'&&stateOperate!='编辑'&&stateOperate!='详情'&&stateOperate!='复制'" class="m-4" style="margin-bottom: 0px!important;">
														<div   role="alert" style="" class="el-alert  el-alert--primary is-light">
															<i    class="el-alert__icon el-icon-info"></i><div class="el-alert__content">
														<span class="el-alert__title" >欢迎您使用JHDMS管理系统，如有疑问请咨询集合系统团队！！！</span>
														</div></div>
													</div> -->
								<router-view></router-view>
						</div >
						</section>
			</el-container>
		</transition>
		<transition v-else name="fade" mode="out-in">
			<router-view></router-view>
		</transition>
</template>

<script>
	import app from './app'
	  export default {
	        ...app
	    }
</script>
<style >
	@import "./style/font.css";
	/* body{font-family: PingFang SC;box-sizing: border-box;} */
	/* @font-face {
	font-family: Inter, Roboto, Oxygen, Fira Sans, Helvetica Neue, sans-serif;
	    font-family-mono: "JetBrains Mono", source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
	  src: url('https://gstatic.loli.net/s/inter/v7/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2') format('truetype');
	 
	} */
	/* @font-face {
	    font-family: PINGFANG;
	    src: url('http://test.jhdms.com/pc/PingFang Medium.ttf')
	} */
	
	* {
	    font-family: PINGFANG,SourceHanSans-CN
	}
	.ql-container.ql-snow {
	    border: 1px solid #DCDFE6!important;
		
		border-bottom-right-radius:4px ;
		border-bottom-left-radius:4px ;
	}
	.ql-toolbar.ql-snow {
	    border: 1px solid #DCDFE6!important;
	border-top-right-radius:4px ;
	border-top-left-radius:4px ;
	border-bottom: none!important;
	}
	

	.container {
		 height: calc(100vh - 60px) !important; 
		width: 100%;
	}

	/* .text-primary {
		color: #409eff !important;
	}
 */
	.header-logo-64 {
		width: 64px;
	}

	.header-logo-200 {
		/* max-width: 100px; */
	}

	.header-search input {
		/* border: 0px; */
		    /* background-color: rgba(0, 0, 0, 0.1); */
		 /* color: #ffffff; */
	}

	.header-search input::-webkit-input-placeholder {
		/* color: #ffffff; */
		vertical-align: bottom;
	}
.el-header{
	/* box-shadow: 0 2px 4px -1px rgb(0 0 0 / 20%), 0 4px 5px 0 rgb(0 0 0 / 14%), 0 1px 10px 0 rgb(0 0 0 / 12%); */
	box-shadow: 0 1px 0px rgb(150 150 150 / 30%);

	z-index: 112;
}
.el-menu-vertical-demo{
	/* box-shadow: 0 2px 4px -1px rgb(0 0 0 / 20%), 0 4px 5px 0 rgb(0 0 0 / 14%), 0 1px 10px 0 rgb(0 0 0 / 12%); */
	z-index: 111;
	border-right: 0px!important;
}
	.el-header,
	.el-footer {
		max-height: 60px;
	}

	body>.el-container {
		margin-bottom: 40px;
	}

	.badge-item sup {
		top: 24px !important;
		right: 0px !important;
	}

	.el-container:nth-child(5) .el-aside,
	.el-container:nth-child(6) .el-aside {
		line-height: 260px;
	}

	.el-container:nth-child(7) .el-aside {
		line-height: 320px;
	}
	.el-loading-spinner .path {
	    stroke-width: 4!important;
	}
	.el-loading-spinner .el-loading-text {
	    font-size: 16px!important;
	    color: #000!important; 
	}
	.el-message{
		top:60px!important
	}
	
	.el-table .cell {
	  white-space:nowrap!important;
	}
	/* .el-badge__content.is-fixed{
		top:15px!important
	} */
	.badge-class .el-badge__content{
		top:20px !important
	}
	.badge-classr .el-badge__content{
		top:0px!important
	}
	.container-mian .el-scrollbar{
		height: auto!important;
	}
	.el-page-header__content{font-size: 16px!important;}
</style>

<style lang="css">
	@import "app.css";
</style>